import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
export default (function (a, f) {
  return a instanceof _Promise ? a.then(f) : f(a);
});